module.exports = __webpack_public_path__ + "img/nodata.d54048f7.png";